<script>
    import blockUI from './BlockUIService.js';
    import DataService from './DataService.js';
    import moment from "moment";
    import CryptoJS from 'crypto-js';
    export default {
        data() {
            return {
                loginDetails: null,




                Offices: [],

                
                
                /*Local*/
                ServerUrl: 'http://localhost:5000',
                Facebock: 'https://www.facebook.com/p/Traneem-100064940462078/?locale=ar_AR',
                Instagram: 'https://www.instagram.com/traneem5__/',
                TraneemPhone: '+218 94 457 81 48',
                TraneemEmail: 'info@traneem.ly',
                PlatFormPass: 'Traneem!@Platformv1',


                WebSiteName: 'الأرشفة',
                BuildFor: 'وزارة الصحة  ',
                logoPath: '/assets/img/1/logo1.png',



            }
        },
        methods: {

            encrypt: function encrypt(data, SECRET_KEY) {
                var dataSet = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY);
                dataSet = dataSet.toString();
                return dataSet;
            },
            decrypt: function decrypt(data, SECRET_KEY) {
                data = CryptoJS.AES.decrypt(data, SECRET_KEY);
                data = JSON.parse(data.toString(CryptoJS.enc.Utf8));
                return data;
            },

            async CheckLoginStatus() {
                try {
                    this.loginDetails = JSON.parse(this.decrypt(localStorage.getItem('currentUser-client'), this.PlatFormPass));
                    const res = await DataService.IsLoggedin();
                    if (!res.data)
                        this.logout();
                } catch (error) {
                    this.logout();
                }
            },
           
            async CheckLoginStatusRequierd() {
                try {
                    this.loginDetails = JSON.parse(this.decrypt(localStorage.getItem('currentUser-client'), this.PlatFormPass));
                    if (this.loginDetails != null) {
                        /*this.logout();*/
                    } else {
                        this.logout();
                    }
                } catch (error) {
                    this.logout();
                }
            },

            async logout() {
                localStorage.removeItem('currentUser-client');
                localStorage.clear();
                document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });

                this.$http.Logout()
                    .then(() => {
                        window.location.href = "/Login";
                    })

                window.location.href = "/Login";
            },



            GetFirstChar(str) {
                return str.length <= 20 ? str : str.substring(0, 10);
            },


            moment(date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('DD/MM/YYYY');
            },

            momentTime(date) {
                if (date === null) {
                    return "------";
                }
                // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
                return moment(date).format('DD/MM/YYYY ||  h:mm a');
            },

            ChangeDate(date) {
                if (date === null) {
                    return "فارغ";
                }
                return moment(date).format("YYYY-MM-DD");
            },

           





            //Dictionaries
            async GetAllOffices(Id) {
                this.Offices = [],
                    blockUI.Start();
                try {
                    const res = await DataService.GetOfficesById(Id);
                    this.Offices = res.data.info;
                    blockUI.Stop();
                } catch (err) {
                    blockUI.Stop();
                }
            },
            





        }
    }
</script>
